import { useCallback, useState } from "react";
import { useQuery } from "react-query";

import { useIvideon } from "./useIvideon";

export const useGetIvideonDealerDocs = () => {
  const [params, setParams] = useState<string>();
  const { getIvideonDealerDocs } = useIvideon();

  const getRequestParams = useCallback((props: string) => {
    setParams(props);
  }, []);

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["ivideonDealerDocs", params],
    queryFn: () => getIvideonDealerDocs(params!),
    onError: (error) => {
      console.log(error);
    },
    enabled: !!params,
  });
  return { data: data?.data, isLoading, isError, getRequestParams, refetch };
};
